<template>
    <div class="mainpage">
        <template v-if="!success">
            <div class="whitebox">
                <h1>Sign Up</h1>
                <h3>Please fill out the form below.</h3>
                <el-form :rules="rules" :model="account" ref="ruleForm" style="padding: 30px 0 0 0;font-size: 14px">

                    <el-form-item prop="email" style="width: 100%;height: auto;">
                        <input placeholder="Email address" v-model.trim="account.email" type="email"
                               @keydown.enter="check">
                    </el-form-item>

                    <el-form-item prop="password" style="width: 100%;height: auto;">
                        <input placeholder="Password" type="password" v-model.trim="account.password"
                               @keydown.enter="check">
                    </el-form-item>

                    <button type="button" @click="check">Continue</button>

                </el-form>
            </div><!--whitebox end--->
        </template>
        <template v-else>
            <div class="whitebox t_center">
                <h1>Thanks for your registration!</h1>
                <p>There are 65 questions coming up.
                    It may take you 15-30 minutes to answer them all.
                    Your patience will be appreciated. Are you ready for the test?</p>
                <button @click="goto">Continue</button>
            </div><!--whitebox end--->
        </template>
    </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';

    let newTitle = 'Join kinktest',
        newDescription = 'If you want to save your test results, please sign up by using your email address.'
    export default {
        name: "signup",
        data() {
            return {
                account: {
                    email: '',
                    password: ''
                },
                rules: {
                    email: [{type: "email", message: 'Invalid format', trigger: 'blur'},
                        {required: true, message: 'Can\'t be empty', trigger: 'blur'}],
                    password: [{required: true, message: 'Can\'t be empty', trigger: 'blur'}]
                },
                success: false, //signup is success
            }
        },
        mounted(){
            let oldTitle = document.head.querySelector('title').innerText
            document.head.querySelector('title').innerText = newTitle
            let meta = document.head.querySelector('meta[name="description"]')
            if(!meta){
                meta = document.head.appendChild(document.createElement('meta'))
                meta.setAttribute('name','description')
            }
            let oldMetaInfo = meta.getAttribute('content')
            meta.setAttribute('content',newDescription)
            let ogMeta = document.head.querySelector('meta[property="og:description"]')
            if(!ogMeta){
                ogMeta = document.head.appendChild(document.createElement('meta'))
                ogMeta.setAttribute('property','og:description')
            }
            let oldOgMetaInfo = ogMeta.getAttribute('content')
            ogMeta.setAttribute('content',newDescription)
            this.doBack = ()=>{
                document.head.querySelector('title').innerText = oldTitle
                meta.setAttribute('content',oldMetaInfo)
                ogMeta.setAttribute('content',oldOgMetaInfo)
            }
        },
        destroyed(){
            if(this.doBack)
                this.doBack()
        },
        methods: {
            check() {
                this.$refs.ruleForm.validate(v => {
                    if (v) {
                        util.axios.post(config.signup_url, this.account).then(data => {
                            if (data && data.user) {
                                this.success = true;
                                this.$store.commit('setUser', data);
                            }
                        })
                    }
                });
            },
            goto() {
                this.$router.push('/starttest');
            }
        }
    }
</script>

<style scoped>

</style>
